import { mergeObjectTypes } from '../cacheHelpers';

const LocalDateTimeRange = {
  merge: mergeObjectTypes
};

export default LocalDateTimeRange;
